(function () {
  function expand(counts) {
    const out = [];
    for (const pair of counts) {
      for (let i = 0; i < pair[0]; i++) out.push(pair[1]);
    }
    return out;
  }

  const BUILTIN = [
    {
      id: "pg-annie",
      name: "Annie — Dark Child",
      tagline: "Proving Grounds starter: cheap units and fiery spells (Fury/Chaos)",
      legend: "ogs-017-024",
      champion: "ogs-001-024",
      battlefields: ["ogn-296-298", "ogn-286-298", "ogn-285-298"],
      runes: { fury: 6, chaos: 6 },
      deck: expand([
        [3, "ogn-185-298"], [3, "ogn-171-298"], [2, "ogn-013-298"], [3, "ogn-176-298"],
        [2, "ogs-010-024"], [2, "ogs-001-024"], [3, "ogn-191-298"], [3, "ogn-174-298"],
        [2, "ogs-018-024"], [3, "ogn-169-298"], [2, "ogs-011-024"], [3, "ogs-003-024"],
        [3, "ogn-170-298"], [3, "ogn-005-298"], [3, "ogs-002-024"],
      ]),
    },
    {
      id: "pg-yi",
      name: "Master Yi — Wuju Bladesman",
      tagline: "Proving Grounds starter: lone defenders and combat tricks (Calm/Body)",
      legend: "ogs-019-024",
      champion: "ogs-004-024",
      battlefields: ["ogn-279-298", "ogn-282-298", "ogn-283-298"],
      runes: { calm: 6, body: 6 },
      deck: expand([
        [3, "ogn-046-298"], [3, "ogn-127-298"], [2, "ogn-129-298"], [3, "ogn-048-298"],
        [3, "ogn-134-298"], [3, "ogn-052-298"], [3, "ogn-055-298"], [2, "ogs-020-024"],
        [2, "ogs-004-024"], [3, "ogn-049-298"], [3, "ogs-008-024"], [3, "ogs-005-024"],
        [2, "ogs-009-024"], [3, "ogn-137-298"], [2, "ogn-142-298"],
      ]),
    },
    {
      id: "pg-lux",
      name: "Lux — Lady of Luminosity",
      tagline: "Proving Grounds starter: control and big spells (Mind/Order)",
      legend: "ogs-021-024",
      champion: "ogs-014-024",
      battlefields: ["ogn-288-298", "ogn-291-298", "ogn-293-298"],
      runes: { mind: 6, order: 6 },
      deck: expand([
        [3, "ogn-210-298"], [3, "ogn-103-298"], [2, "ogn-084-298"], [3, "ogn-087-298"],
        [2, "ogs-014-024"], [3, "ogn-219-298"], [3, "ogs-016-024"], [2, "ogs-006-024"],
        [2, "ogn-088-298"], [3, "ogn-095-298"], [3, "ogn-206-298"], [3, "ogn-085-298"],
        [3, "ogs-012-024"], [2, "ogs-022-024"], [3, "ogs-015-024"],
      ]),
    },
    {
      id: "pg-garen",
      name: "Garen — Might of Demacia",
      tagline: "Proving Grounds starter: wide armies that overwhelm (Body/Order)",
      legend: "ogs-023-024",
      champion: "ogs-013-024",
      battlefields: ["ogn-294-298", "ogn-293-298", "ogn-290-298"],
      runes: { body: 6, order: 6 },
      deck: expand([
        [3, "ogn-129-298"], [3, "ogn-210-298"], [3, "ogn-206-298"], [3, "ogn-130-298"],
        [3, "ogn-211-298"], [3, "ogn-132-298"], [3, "ogn-222-298"], [3, "ogn-219-298"],
        [2, "ogs-024-024"], [2, "ogn-131-298"], [2, "ogn-215-298"], [2, "ogs-013-024"],
        [2, "ogs-007-024"], [3, "ogs-015-024"], [3, "ogs-016-024"],
      ]),
    },
    {
      id: "demo-darius",
      name: "Darius — Hand of Noxus",
      tagline: "Demo deck: Noxian aggression and Legion payoffs (Fury/Order)",
      legend: "ogn-253-298",
      champion: "ogn-027-298",
      battlefields: ["ogn-275-298", "ogn-286-298", "ogn-294-298"],
      runes: { fury: 6, order: 6 },
      deck: expand([
        [3, "ogn-010-298"], [3, "ogn-001-298"], [3, "ogn-013-298"], [3, "ogn-009-298"],
        [3, "ogn-004-298"], [3, "ogn-005-298"], [3, "ogn-012-298"], [3, "ogn-210-298"],
        [3, "ogn-215-298"], [3, "ogn-219-298"], [3, "ogn-217-298"], [3, "ogn-206-298"],
        [3, "ogn-027-298"], [1, "ogn-254-298"],
      ]),
    },
    {
      id: "demo-leona",
      name: "Leona — Radiant Dawn",
      tagline: "Demo deck: stuns and steady defense (Calm/Order)",
      legend: "ogn-261-298",
      champion: "ogn-238-298",
      battlefields: ["ogn-280-298", "ogn-292-298", "ogn-297-298"],
      runes: { calm: 6, order: 6 },
      deck: expand([
        [3, "ogn-052-298"], [3, "ogn-054-298"], [3, "ogn-049-298"], [3, "ogn-050-298"],
        [3, "ogn-051-298"], [3, "ogn-055-298"], [3, "ogn-210-298"], [3, "ogn-215-298"],
        [3, "ogn-219-298"], [3, "ogn-211-298"], [3, "ogn-206-298"], [3, "ogn-238-298"],
        [1, "ogn-262-298"],
      ]),
    },
  ];

  const BATTLEFIELDS = 3;
  const DECK_SIZE = 40;
  const RUNE_TOTAL = 12;
  const MAX_COPIES = 3;
  const SIDE_MAX = 10;

  const LS_KEY = "riftbound-custom-decks";
  const FAV_KEY = "riftbound-favorite-decks";

  function migrate(deck) {
    if (!deck.battlefields) deck.battlefields = deck.battlefield ? [deck.battlefield] : [];
    delete deck.battlefield;
    if (!Array.isArray(deck.side)) deck.side = [];
    return deck;
  }

  function tally(ids) {
    const out = {};
    for (const id of ids) out[id] = (out[id] || 0) + 1;
    return out;
  }

  function sameTally(a, b) {
    const ta = tally(a);
    const tb = tally(b);
    for (const k in ta) if (ta[k] !== tb[k]) return false;
    for (const k in tb) if (ta[k] !== tb[k]) return false;
    return true;
  }

  function loadCustom() {
    try {
      const raw = window.localStorage && localStorage.getItem(LS_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.map(migrate) : [];
    } catch (e) {
      return [];
    }
  }

  function loadFavs() {
    try {
      const raw = window.localStorage && localStorage.getItem(FAV_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function (id) { return typeof id === "string"; }) : [];
    } catch (e) {
      return [];
    }
  }

  function persistFavs(arr) {
    try {
      if (window.localStorage) localStorage.setItem(FAV_KEY, JSON.stringify(arr));
    } catch (e) { }
  }

  function persistCustom(arr) {
    try {
      if (window.localStorage) localStorage.setItem(LS_KEY, JSON.stringify(arr));
    } catch (e) { }
  }

  let LIBRARY = [];
  let libraryPromise = null;
  let libraryReady = false;

  const Decklists = {
    BATTLEFIELDS: BATTLEFIELDS,
    DECK_SIZE: DECK_SIZE,
    RUNE_TOTAL: RUNE_TOTAL,
    MAX_COPIES: MAX_COPIES,
    SIDE_MAX: SIDE_MAX,

    RUNE_CARDS: {
      fury: "Fury Rune", calm: "Calm Rune", mind: "Mind Rune",
      body: "Body Rune", chaos: "Chaos Rune", order: "Order Rune",
    },

    builtin() {
      return BUILTIN.slice();
    },

    library() {
      return LIBRARY.slice();
    },

    libraryReady() {
      return libraryReady;
    },

    loadLibrary() {
      if (libraryPromise) return libraryPromise;
      if (typeof fetch !== "function") {
        libraryReady = true;
        libraryPromise = Promise.resolve([]);
        return libraryPromise;
      }
      libraryPromise = fetch("/api/meta/lists")
        .then(function (r) { return r.ok ? r.json() : []; })
        .then(function (arr) {
          LIBRARY = (Array.isArray(arr) ? arr : []).filter(function (d) {
            return d && d.id && Array.isArray(d.deck) && d.deck.length;
          }).map(migrate);
          libraryReady = true;
          return LIBRARY;
        })
        .catch(function () { libraryReady = true; return LIBRARY; });
      return libraryPromise;
    },

    favorites() {
      return loadFavs();
    },

    isFavorite(id) {
      return loadFavs().indexOf(id) >= 0;
    },

    setFavorite(id, on) {
      const arr = loadFavs().filter(function (x) { return x !== id; });
      if (on) arr.push(id);
      persistFavs(arr);
      return on;
    },

    toggleFavorite(id) {
      return Decklists.setFavorite(id, !Decklists.isFavorite(id));
    },

    custom() {
      return loadCustom();
    },

    exportCollection() {
      const keep = ["id", "name", "tagline", "legend", "champion", "battlefields", "runes", "deck", "side"];
      const strip = function (d) {
        const out = {};
        for (const k of keep) if (d[k] !== undefined) out[k] = JSON.parse(JSON.stringify(d[k]));
        return out;
      };
      return LIBRARY.map(strip).concat(loadCustom().map(strip));
    },

    importCollection(input) {
      const list = Array.isArray(input) ? input : (input && typeof input === "object" ? [input] : []);
      const reserved = {};
      for (const d of BUILTIN.concat(LIBRARY)) reserved[d.id] = true;
      const arr = loadCustom();
      const out = { added: 0, updated: 0, skipped: [] };
      list.forEach(function (raw, i) {
        if (!raw || typeof raw !== "object" || !Array.isArray(raw.deck)) { out.skipped.push("entry " + (i + 1) + ": not a deck"); return; }
        const deck = migrate(JSON.parse(JSON.stringify(raw)));
        delete deck.builtin;
        delete deck.library;
        if (!deck.id || typeof deck.id !== "string") deck.id = "custom-" + Date.now() + "-" + i;
        if (reserved[deck.id]) deck.id = "custom-" + deck.id;
        if (!deck.name) deck.name = deck.id;
        if (!deck.runes || typeof deck.runes !== "object") deck.runes = {};
        const j = arr.findIndex(function (d) { return d.id === deck.id; });
        if (j >= 0) { arr[j] = deck; out.updated++; } else { arr.push(deck); out.added++; }
      });
      persistCustom(arr);
      return out;
    },

    all() {
      return BUILTIN.map(function (d) { return Object.assign({ builtin: true }, d); })
        .concat(LIBRARY.map(function (d) { return Object.assign({ builtin: true, library: true }, d); }))
        .concat(loadCustom().map(function (d) { return Object.assign({ builtin: false }, d); }));
    },

    get(id) {
      return Decklists.all().find(function (d) { return d.id === id; }) || null;
    },

    saveCustom(deck) {
      migrate(deck);
      const arr = loadCustom();
      const i = arr.findIndex(function (d) { return d.id === deck.id; });
      if (i >= 0) arr[i] = deck;
      else arr.push(deck);
      persistCustom(arr);
    },

    deleteCustom(id) {
      persistCustom(loadCustom().filter(function (d) { return d.id !== id; }));
      Decklists.setFavorite(id, false);
    },

    isChampionUnit(card) {
      if (!card) return false;
      return (card.types || []).indexOf("unit") >= 0 && (card.supertypes || []).indexOf("champion") >= 0;
    },

    isMainDeckCard(card) {
      if (!card || card.token) return false;
      const t = card.types || [];
      if (t.indexOf("legend") >= 0 || t.indexOf("battlefield") >= 0 || t.indexOf("rune") >= 0) return false;
      return t.indexOf("unit") >= 0 || t.indexOf("spell") >= 0 || t.indexOf("gear") >= 0;
    },

    copyCap(card) {
      const unique = card && (card.keywords || []).some(function (k) { return k.name === "Unique"; });
      return unique ? 1 : MAX_COPIES;
    },

    validate(deck) {
      const errs = [];
      const find = window.RB.Setup.findCard;
      if (!deck.name) errs.push("deck needs a name");
      if (!deck.legend || !find(deck.legend)) errs.push("legend not found");
      if (!deck.champion || !find(deck.champion)) errs.push("champion not found");
      const fields = deck.battlefields || [];
      if (fields.length !== BATTLEFIELDS) {
        errs.push("choose exactly " + BATTLEFIELDS + " battlefields (currently " + fields.length + ")");
      }
      for (const id of fields) if (!find(id)) errs.push("battlefield not found: " + id);
      if (new Set(fields).size !== fields.length) errs.push("the same battlefield is chosen twice");
      const cards = deck.deck || [];
      const side = deck.side || [];
      if (cards.length !== DECK_SIZE) {
        errs.push("main deck must be exactly " + DECK_SIZE + " cards (currently " + cards.length + ")");
      }
      if (side.length > SIDE_MAX) {
        errs.push("side deck holds at most " + SIDE_MAX + " cards (currently " + side.length + ")");
      }
      if (cards.indexOf(deck.champion) < 0) errs.push("the chosen champion must be one of the 40 deck cards");
      const seen = {};
      for (const id of side) {
        if (seen[id]) continue;
        seen[id] = true;
        const c = find(id);
        if (c && !Decklists.isMainDeckCard(c)) {
          errs.push("the side deck holds main deck cards only: " + c.name + " is not one");
        }
      }
      const byName = {};
      for (const id of cards.concat(side)) {
        const c = find(id);
        if (!c) { errs.push("card not found: " + id); continue; }
        byName[c.name] = (byName[c.name] || 0) + 1;
      }
      const where = side.length ? " between main and side deck" : "";
      for (const n in byName) {
        const cap = Decklists.copyCap(find(n));
        if (byName[n] > cap) {
          errs.push(cap === 1
            ? "more than 1 copy of " + n + where + " (Unique, rule 825)"
            : "more than " + cap + " copies of " + n + where);
        }
      }
      let runeTotal = 0;
      for (const d in deck.runes || {}) runeTotal += deck.runes[d];
      if (runeTotal !== RUNE_TOTAL) {
        errs.push("rune deck must be exactly " + RUNE_TOTAL + " runes (currently " + runeTotal + ")");
      }
      return errs;
    },

    pool(deck) {
      return (deck.deck || []).concat(deck.side || []);
    },

    swapProblem(registered, live) {
      if (!registered || !live) return "no registered deck to sideboard from";
      if (!Array.isArray(live.deck) || !Array.isArray(live.side)) return "that deck has no main and side deck";
      if (live.legend !== registered.legend) return "the legend may not change while sideboarding";
      if (live.deck.length !== DECK_SIZE) {
        return "the main deck must be back at " + DECK_SIZE + " cards (currently " + live.deck.length + ")";
      }
      if (!sameTally(Decklists.pool(live), Decklists.pool(registered))) {
        return "cards must be exchanged one for one with the registered main and side deck";
      }
      const runes = registered.runes || {};
      const now = live.runes || {};
      for (const d in Decklists.RUNE_CARDS) {
        if ((runes[d] || 0) !== (now[d] || 0)) return "the rune deck may not change while sideboarding";
      }
      if (!sameTally(live.battlefields || [], registered.battlefields || [])) {
        return "the battlefields may not change while sideboarding";
      }
      if (!live.champion || live.deck.indexOf(live.champion) < 0) {
        return "the chosen champion must be one of the " + DECK_SIZE + " main deck cards";
      }
      return null;
    },

    toSetupPlayer(deck, name, opts) {
      opts = opts || {};
      const main = deck.deck.slice();
      const ci = main.indexOf(deck.champion);
      if (ci >= 0) main.splice(ci, 1);
      const runes = [];
      for (const dom in deck.runes) {
        for (let i = 0; i < deck.runes[dom]; i++) runes.push(Decklists.RUNE_CARDS[dom]);
      }
      return {
        name: name || deck.name.split(" — ")[0],
        legend: deck.legend,
        champion: deck.champion,
        deck: main,
        runes: runes,
        battlefields: opts.battlefields ? opts.battlefields.slice() : (deck.battlefields || []).slice(),
      };
    },
  };

  window.RB = window.RB || {};
  window.RB.Decklists = Decklists;
})();
